import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth-section/auth/auth.component';
import { AuthguardService } from './auth-section/auth-service/authguard.service';
import { ProfileComponent } from './profile-section/profile/profile.component';
import { DashboardComponent } from './dashboard-section/dashboard/dashboard.component';
import { LogoutGuardService } from './auth-section/auth-service/logout-guard.service';
import { DocregComponent } from './registeration-section/docreg/docreg.component';
import { AppointmentComponent } from './appointment-section/appointment/appointment.component';
import { AppointmentDashbordComponent } from './appointment-section/appointment-dashbord/appointment-dashbord.component';
import { AddClinicComponent } from './profile-section/add-clinic/add-clinic.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { PatloginComponent } from './Patient/login/patlogin/patlogin.component';
import { PatdashboardComponent } from './Patient/dash/patdashboard/patdashboard.component';
import { PatsignupComponent } from './Patient/signup/patsignup/patsignup.component';
import { PatotpComponent } from './Patient/otp/patotp/patotp.component';
import { AlldoctorComponent } from './Patient/doctorlist/alldoctor/alldoctor.component';
import { SingledokComponent } from './Patient/single-doc/singledok/singledok.component';
import { AllhospitalComponent } from './Patient/hospitallist/allhospital/allhospital.component';
import { LabsComponent } from './Patient/lablist/labs/labs.component';
import { MhistoryComponent } from './Patient/medicalhistory/mhistory/mhistory.component';
import { DokcategoryComponent } from './Patient/doctorcategory/dokcategory/dokcategory.component';
import { AppointmentsComponent } from './Patient/patappointments/appointments/appointments.component';
import { FindDoctorComponent } from './find-doctor/find-doctor/find-doctor.component';
import { ViewDoctorComponent} from './viewDoctor/view-doctor/view-doctor.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { DownloadPageComponent } from './download-page/download-page.component';
import { PricingComponent } from './pricing/pricing.component';
import { EmergencyComponent } from './profile-section/emergency/emergency.component';
import { RefrenceComponent } from './refrence/refrence.component';
import { MarketingManagerComponent } from './MR/medical-r/marketing-manager/marketing-manager.component';
import { CompanyLoginComponent } from './MR/medical-r/company-login/company-login.component';
import { MedicalRComponent } from './MR/medical-r/medical-r.component';
import { MrAppointmentComponent } from './MR/medical-r/mr-appointment/mr-appointment.component';
import { MrSignupComponent } from './MR/mr-signup/mr-signup.component';
import { LabReportsComponent } from './lab-reports/lab-reports.component';
import { MembersComponent } from './members/members.component';
import { TestComponent } from './test/test.component';
import { MemberRecordComponent } from './members/member-record/member-record.component';
import { PatientSubscriptionComponent } from './patient-subscription/patient-subscription.component';
const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    pathMatch: 'full',
    canActivate: [LogoutGuardService],
  },
  {
    path: 'pas/profile',
    component: ProfileComponent,
    pathMatch: 'full',
    canActivate: [AuthguardService],
  },
  {
    path: 'pas/appointments',
    component: AppointmentComponent,
    pathMatch: 'full',
    canActivate: [AuthguardService],
  },
  {
    path: 'pas/refrence',
    component: RefrenceComponent,
    pathMatch: 'full',
    canActivate: [AuthguardService],
  },
  {
    path: 'pas/dashboard/appointmentsdashboard',
    component: AppointmentDashbordComponent,
    pathMatch: 'full',
    canActivate: [AuthguardService],
  },
  {
    path: 'pas/dashboard',
    component: DashboardComponent,
    pathMatch: 'full',
    canActivate: [AuthguardService],
  },
  {
    path: 'pas/members',
    component: MembersComponent,
    pathMatch: 'full',
    canActivate: [AuthguardService],
  },
  {
    path: 'pas/test',
    component: TestComponent,
    pathMatch: 'full',
    canActivate: [AuthguardService],
  },
  {
    path: 'allhoslist',
    component: AllhospitalComponent,
    pathMatch: 'full',
  },
  {
    path: 'alltestlablist',
    component: LabsComponent,
    pathMatch: 'full',
  },
  {
    path: 'pas/Emergency',
    component:EmergencyComponent,
    pathMatch:'full',
  },
  {
    path: 'medicalhist',
    component: MhistoryComponent,
    pathMatch: 'full',
  },
  {
    path: 'Market',
    component: MarketingManagerComponent,
    pathMatch: 'full',
  },
  {
    path: 'Company',
    component: CompanyLoginComponent,
    pathMatch: 'full',
  },
  {
    path: 'mr',
    component: MedicalRComponent,
    pathMatch: 'full',
  },
  {
    path: 'mrappointment',
    component: MrAppointmentComponent,
    pathMatch: 'full',
  },
  {
    path: 'mrSignup',
    component: MrSignupComponent,
    pathMatch: 'full',
  },
  {
    path: 'patappointment',
    component: AppointmentsComponent,
    pathMatch: 'full',
  },
  {
    path: 'pas/addclinic',
    component: AddClinicComponent,
    pathMatch: 'full',
    canActivate: [AuthguardService],
  },
  // {
  //   path: 'registration',
  //   component: DocregComponent,
  //   pathMatch: 'full',
  //   canActivate: [LogoutGuardService],
  // },
  {
    path: 'doklist',
    component: AlldoctorComponent,
    pathMatch: 'full',
  },
  {
    path: 'patlogin',
    component: PatloginComponent,
    pathMatch: 'full',
  },
  {
    path: 'dokcategory',
    component: DokcategoryComponent,
    pathMatch: 'full',
  },
  {
    path: 'sindok',
    component: SingledokComponent,
    pathMatch: 'full',
  },
  {
    path: 'patdash',
    component: PatdashboardComponent,
    pathMatch: 'full',
  },
  {
    path: 'patsignup',
    component: PatsignupComponent,
    pathMatch: 'full',
  },
  {
    path: 'patotp',
    component: PatotpComponent,
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full',
  },
  {
    path: 'pas',
    redirectTo: '/pas/dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LandingPageComponent,
    pathMatch: 'full',
  },
  {
    path: 'finddoctor',
    component: FindDoctorComponent,
    pathMatch: 'full',
  },
  {
    path: 'viewdoctor/:id',
    component: ViewDoctorComponent,
    pathMatch: 'full',
  },
  {
    path: 'termsconditoin',
    component: TermsConditionComponent,
    pathMatch: 'full',
  },
  {
    path: 'refundpolicy',
    component: RefundPolicyComponent,
    pathMatch: 'full',
  },
  {
    path: 'privacypolicy',
    component: PrivacyPolicyComponent,
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: AuthComponent,
    pathMatch: 'full',
  },
  {
    path: 'contact',
    component: ContactUsComponent,
    pathMatch: 'full',
  },
  {
    path: 'about',
    component: AboutUsComponent,
    pathMatch: 'full',
  },
  {
    path: 'download',
    component: DownloadPageComponent,
    pathMatch: 'full',
  },
  {
    path: 'pricing',
    component: PricingComponent,
    pathMatch: 'full',
  },
  {
    path: 'psub',
    component: PatientSubscriptionComponent,
    pathMatch: 'full',
  },
  { path: 'date-range-table/:startDate/:endDate/:id', component: MemberRecordComponent,canActivate: [AuthguardService],pathMatch:'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
